import React from 'react';
import { Link } from 'react-router-dom';
import HoverFollow from './HoverFollow';

export default function ProjectList({ projects }) {
  return (
    <section className='grid'>
      {projects.map((project) => (
        <Link key={project.id} to={`/portfolio/${project.id}`} className="block">
          <HoverFollow 
            title={project.title} 
            column2Text={project.category} 
            year={project.year} 
            location={project.location}
            imageUrl={project.imageUrl} 
          />
        </Link>
      ))}
    </section>
  );
}